<template>
  <fragment>
    <div class="container-fiuld clearfix" v-if="member">
      <div class="btn-group-box m-b-15 clearfix">
        <div class="btn-group pull-left clearfix">
          <div class="select pull-left m-r-5">
            <!-- <a class="btn round" @click="$emit('onEmail')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="v-mid m-r-5"
                width="22"
                height="20"
                viewBox="0 0 22 20"
              >
                <path
                  class="msg-i"
                  d="M262.519,1266.28a0.158,0.158,0,0,0,.019.08c0,0.02.019,0.06,0.019,0.08a0.473,0.473,0,0,1,.019.08,0.3,0.3,0,0,1,.038.08c0.019,0.02.019,0.04,0.038,0.06a0.107,0.107,0,0,1,.038.06l0.057,0.06,0.019,0.02a0.019,0.019,0,0,1,.019.02,0.447,0.447,0,0,0,.209.12,0.037,0.037,0,0,1,.038.02,0.91,0.91,0,0,0,.228.04h20.5a0.91,0.91,0,0,0,.228-0.04,0.037,0.037,0,0,0,.038-0.02,2.043,2.043,0,0,0,.209-0.12,0.019,0.019,0,0,0,.019-0.02l0.019-.02,0.057-.06a0.107,0.107,0,0,0,.038-0.06c0.019-.02.019-0.04,0.038-0.06a0.3,0.3,0,0,0,.038-0.08,0.1,0.1,0,0,0,.019-0.08c0-.02.019-0.06,0.019-0.08a0.473,0.473,0,0,0,.019-0.08v-18.46a0.792,0.792,0,0,0-.779-0.82H263.279a0.792,0.792,0,0,0-.779.82v18.38A0.1,0.1,0,0,1,262.519,1266.28Zm2.432-.94,5.756-7.25,2.394,1.76a0.752,0.752,0,0,0,.874,0l2.394-1.76,5.756,7.25H264.951Zm18.067-1.44-5.377-6.75,5.358-3.94v10.69h0.019Zm-18.96-15.26H283v2.58l-9.461,6.95-9.48-6.95v-2.58Zm0,4.57,5.357,3.94-5.357,6.75v-10.69Z"
                  transform="translate(-262.5 -1247)"
                />
              </svg> 전자우편 보내기
            </a> -->
          </div>
          <div class="select pull-left m-r-5">
            <a class="btn round" @click="$emit('onSms')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="v-mid m-r-5"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <path
                  class="sms-i"
                  d="M386.428,1249.93a10,10,0,0,1,14.807,13.41,3.719,3.719,0,0,0,1.575,1.82,0.933,0.933,0,0,1-.268,1.76,5.3,5.3,0,0,1-.708.05h0a6.478,6.478,0,0,1-3.6-1.16A10,10,0,0,1,386.428,1249.93Zm0.8,13.34a8.909,8.909,0,0,0,10.763,1.38,0.59,0.59,0,0,1,.285-0.08,0.621,0.621,0,0,1,.348.11,5.414,5.414,0,0,0,3.138,1.16,5.789,5.789,0,0,1-1.714-2.37,0.561,0.561,0,0,1,.1-0.6A8.871,8.871,0,1,0,387.229,1263.27Zm2.082-9.57h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1253.7Zm0,2.73h8.38a0.569,0.569,0,0,1,.565.57,0.561,0.561,0,0,1-.565.56h-8.38a0.562,0.562,0,0,1-.566-0.56A0.573,0.573,0,0,1,389.311,1256.43Zm0,2.74h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1259.17Z"
                  transform="translate(-383.5 -1247)"
                />
              </svg> 문자 보내기
            </a>
          </div>
        </div>
        <div class="btn-group pull-right clearfix">
          <div class="select pull-left m-r-5">
            <router-link
              class="btn round pull-left"
              :to="`/users/detail/${member.mberId}/modify`"
            >정보수정</router-link>
          </div>
        </div>
      </div>

      <p class="f-18 text-darkgray m-b-10">기본정보</p>
      <div class="col-md-6 p-l-0">
        <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">이름</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              v-model="member.mberName"
              placeholder="이름"
              disabled
            />
          </div>
        </div>
        <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">아이디</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              v-model="member.mberId"
              placeholder="아이디"
              disabled
            />
          </div>
        </div>
        <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">비밀번호</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              placeholder="오류횟수"
              :value="`오류횟수 ${member.passwordErrCnt ? member.passwordErrCnt : 0}`"
            />
            <span class="input-group-addon button v-mid" style="width: 154px;">
              <button class="btn btn-red round" type="button" @click="resetIncorrect()">초기화</button>
              <button class="btn round" type="button" @click="resetPassword()">임시발급</button>
            </span>
          </div>
        </div>
        <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">휴대전화</span>
            <input
              class="form-control full-width round b-l-0"
              type="text"
              placeholder="010-0000-0000"
              v-model="member.mobileNum"
              disabled
            />
            <span class="input-group-addon v-mid p-l-5" style="width:120px">
              <input
                class="form-control full-width round"
                type="text"
                placeholder
                :value="member.mobileRecvEnable ? '수신허용' : '수신미허용'"
                disabled
              />
            </span>
          </div>
        </div>
        <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">전자우편</span>
            <input
              class="form-control full-width round"
              type="text"
              placeholder="temp@email.com"
              v-model="member.email"
              disabled
            />
            <span class="input-group-addon v-mid p-l-5" style="width:120px">
              <input
                class="form-control full-width round"
                type="text"
                placeholder
                :value="member.emailRecvEnable ? '수신허용' : '수신미허용'"
                disabled
              />
            </span>
          </div>
        </div>
        <!-- <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">가입일</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              :value="member.regDate | parseRegDate"
              placeholder="yyyy-mm-dd"
              disabled
            />
          </div>
        </div>
        <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">최근접속일</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              :value="member.lastLoginDate | parseRegDate"
              placeholder="yyyy-mm-dd"
              disabled
            />
          </div>
        </div>
        <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">로그인 횟수</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              :value="Number(member.loginCount) || 0+' 회'"
              disabled
            />
          </div>
        </div>
        <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">작성게시물수</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              :value="articleCount"
              placeholder="yyyy-mm-dd"
              disabled
            />
          </div>
        </div>
        <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">작성댓글수</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              :value="commentCount"
              placeholder="yyyy-mm-dd"
              disabled
            />
          </div>
        </div>
        <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">수강 신청수</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              :value="applCountTotal+'건 중 취소 '+applCountCancel+'건, 진행중 '+applCountProgress+'건, 완료 '+applCountDone+'건'"
              placeholder="yyyy-mm-dd"
              disabled
            />
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="round m-b-10">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">직업</span>
            <input
              class="form-control full-width b-l-0"
              :value="userJob"
              type="text"
              placeholder
              disabled
            />
          </div>
        </div>
        <div
          class="round m-b-10"
          v-for="question in jobQuestions"
          :key="`workinfo-${hash(question)}`"
        >
          <div class="input-group full-width">
            <span
              class="input-group-addon label not bg-blue v-mid text-white"
            >{{question.workInfoName}}</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              placeholder
              :value="getJobAnswer(question.workInfoName)"
              disabled
            />
          </div>
        </div> -->
      </div>

      <template v-if="member.instEnable">
        <div class="clearfix"></div>

        <p class="f-18 text-darkgray m-b-5 m-t-30">강사권한 관리</p>
        <div class="m-b-15">
          <span class="text-blue f-20 m-r-10">|</span>

          <span
            class="label auth_label"
            :style="auth.color ? {'background-color': auth.color} : {}"
            v-for="auth in member.authAllotList.filter(e=>e.type==='강사')"
            :key="`auth-label-${hash(auth)}`"
          >{{auth.authName}}</span>
        </div>

        <div class="round m-b-10 col-md-6 p-l-0">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">지역국어원</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              placeholder
              :value="member.instInfoList[0]? member.instInfoList[0]['localKorInst'] : ''"
              disabled
            />
          </div>
        </div>
        <div class="round m-b-10 col-md-6 p-r-0">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">은행명</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              placeholder
              :value="member.instInfoList[0]? member.instInfoList[0]['bankName'] : ''"
              disabled
            />
          </div>
        </div>

        <div class="round m-b-10 col-md-6 p-l-0">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">예금주</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              placeholder
              :value="member.instInfoList[0]? member.instInfoList[0]['depositor'] : ''"
              disabled
            />
          </div>
        </div>
        <div class="round m-b-10 col-md-6 p-r-0">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">계좌번호</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              placeholder
              :value="member.instInfoList[0]? member.instInfoList[0]['accountInfo'] : ''"
              disabled
            />
          </div>
        </div>

        <div class="round m-b-10 col-md-12 p-l-0 p-r-0">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">이력서</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              :value="member.instInfoList[0].resumeFile?member.instInfoList[0].resumeFile.orignlFileNm:''"
            />
          </div>
        </div>
        <div class="round m-b-10 col-md-12 p-l-0 p-r-0">
          <div class="input-group full-width">
            <span class="input-group-addon label not bg-blue v-mid text-white">약력</span>
            <input
              class="form-control full-width b-l-0"
              type="text"
              placeholder
              :value="member.instInfoList[0]? member.instInfoList[0]['career'] : ''"
              disabled
            />
          </div>
        </div>
      </template>

      <template v-if="member.adminEnable">
        <div class="clearfix"></div>

        <p class="f-18 text-darkgray m-b-5 m-t-15">관리자권한 관리</p>
        <div class="m-b-30">
          <span class="text-blue f-20 m-r-10">|</span>

          <span
            class="label auth_label"
            :style="auth.color ? {'background-color': auth.color} : {}"
            v-for="auth in member.authAllotList.filter(e=>e.type==='관리자')"
            :key="`auth-label-${hash(auth)}`"
          >{{auth.authName}}</span>
        </div>
      </template>
    </div>

    <modal-confirm
      :config="modals.ModalConfirm"
      @yes="modals.ModalConfirm.show=false"
      @no="modals.ModalConfirm.show=false"
      :key="hash(modals.ModalConfirm)"
    ></modal-confirm>
    <modal-alert
      :config="modals.ModalAlert"
      @close="modals.ModalAlert.show=false;"
      :key="hash(modals.ModalAlert)"
    ></modal-alert>
  </fragment>
</template>

<script>
import fnGetJobData from "../../mixins/fnGetJobData";
import Axios from "axios";
import server from "../../statics/server";
import ModalConfirm from "../../modals/ModalConfirm.vue";
import ModalAlert from "../../modals/ModalAlert.vue";
import moment from "moment";

export default {
  name: "SubviewUserDetail",
  mixins: [fnGetJobData],
  // 마운트
  mounted: function() {
    // 게시물수 얻기
    Axios.post(server.addr() + server.api.ARTICLE, {
      mberId: this.member.mberId
    }).then(response => {
      this.articleCount = response.data.filtered;
    });
    // 댓글수 얻기
    Axios.post(server.addr() + server.api.COMMENT, {
      mberId: this.member.mberId
    }).then(response => {
      this.commentCount = response.data.filtered;
    });
    // 총 수강 신청수 얻기
    Axios.post(server.addr() + server.api.APPL, {
      mberId: this.member.mberId
    }).then(response => {
      this.applCountTotal = response.data.filtered;
    });
  },
  components: {
    ModalConfirm,
    ModalAlert
  },
  props: {
    authList: Array,
    jobQuestions: Array,
    member: Object
  },
  // 컴포넌트 데이터
  data: function() {
    return {
      modals: {
        ModalConfirm: ModalConfirm.default(),
        ModalAlert: ModalAlert.default()
      },
      articleCount: 0,
      commentCount: 0,
      applCountTotal: 0,
      applCountCancel: 0,
      applCountProgress: 0,
      applCountDone: 0
    };
  },
  filters: {
    parseRegDate(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  },
  // 이 컴포넌트에서 구현되어야 할 기능
  methods: {
    getJobAnswer: function(itemName) {
      const answer = this.member.workInfoList.find(e => e.itemName == itemName);
      return answer ? answer.itemValue : "";
    },
    resetIncorrect: async function() {
      try {
        await Axios.patch(
          `${server.addr()}${server.api.MBER}/${this.member.mberId}`,
          {
            passwordErrCnt: 0,
            lockEnable: 0
          }
        );
        this.$emit("onRefresh");
        this.modals.ModalAlert.msg = "초기화되었습니다.";
        this.modals.ModalAlert.show = true;
      } catch (e) {
        this.modals.ModalAlert.msg =
          "네트워크 오류! 서버 관리자에게 문의해주세요";
        this.modals.ModalAlert.show = true;
      }
    },
    resetPassword: async function() {
      try {
        const { data } = await Axios.post(
          `${server.addr()}${server.api.MBER}/${this.member.mberId}/newPassword`
        );
        this.modals.ModalAlert.msg = `새로운 비밀번호 : ${data.password}`;
        this.modals.ModalAlert.show = true;
      } catch (e) {
        this.modals.ModalAlert.msg =
          "네트워크 오류! 서버 관리자에게 문의해주세요";
        this.modals.ModalAlert.show = true;
      }
    },
    // authId로 auth 받아오기
    getAuth: function(authId) {
      return this.authList.find(e => e.authId === authId);
    }
  },
  computed: {
    userJob: function() {
      if (!this.member) return;

      let userJob = "NO DATA";

      this.jobs.forEach(job => {
        userJob = job.code == this.member.workCode ? job.codeNm : userJob;
      });

      return userJob;
    }
  }
};
</script>


<style scoped>
.auth_label.label {
  background-color: #999;
}
.msg-i {
  fill: #999;
  fill-rule: evenodd;
}
.btn-group .btn:hover .msg-i {
  fill: #fff;
  fill-rule: evenodd;
}
.sms-i {
  fill: #999;
  fill-rule: evenodd;
}
.btn-group .btn:hover .sms-i {
  fill: #fff;
  fill-rule: evenodd;
}
.re {
  fill: #999;
  fill-rule: evenodd;
}

.btn-group .btn:hover .re {
  fill: #fff;
  fill-rule: evenodd;
}
</style>